export default __webpack_public_path__ + "static/media/emas.bd19b409.svg";